module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABCUlEQVQ4T92SMUsDQRSEZw6iSGptBH+EYCdWsbWzUTzT3CYoet4viWdQyJ5FjMTG1s5UYhfwR0iq9CFg9EYSMZzJRU7Sud3uzny8N+8Rcx7O6cd/AbjlYJXxxwPA5WyZqPsea6d5Xe2MMnC9kwLJx2zmL5Wk7UZUbY1DLBq/KWgvC4TgXd2G+0PtGLAbBEv5XvwsaP03CMGXXt7ZvK9U+j8Aw8uBOV1zoDbAlXSIujG4cWsvXr//p/bgsORvQWoByE1ABiALN7XwKfmeukiu5x+RukwKJR43ovBqsrKZm1gs+VaSN+qTjOq10KS1NRNgjMm9YfEMcLCA/rm1dvAnQJZxTk0hqymp+wTWqE4RIMkieAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/homepage/select-icon-down.png
// module id = a0tB
// module chunks = 4